export default __webpack_public_path__ + "static/media/anonymus.f25eeda3.jpeg";